export default "assets/42a2d1c3825509473224d4abafcebbbf.svg";